import { useChangeExchangePrice } from '@/hooks/useChangeExchangePrice';
import useConfiguredCurrency from '@/hooks/useConfiguredCurrency';
import { getLanguage } from '@/i18n';
import { TransText } from '@/i18n/trans/text';
import { formatSignedCurrency } from '@/utils/formatSignedCurrency';
import { Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

const localeMap: Record<string, string> = {
  en: 'en-US',
  it: 'it-IT',
};

// Green when the swap is same-or-cheaper (`<= 0`), primary otherwise.
// `null` (never fetched yet, BE rejection, or non-finite payload) renders
// as "-" — better to communicate "value unknown" than to risk misleading
// a financial decision with a stale or fabricated delta.
export const ChangeExchangePriceFooterContent: FC = () => {
  const { exchangePrice } = useChangeExchangePrice();
  const { currency } = useConfiguredCurrency();
  const locale = localeMap[getLanguage()] ?? 'en-US';

  return (
    <div className="flex items-center gap-2">
      <Icons.travelPass className="text-primary" />
      <Typography variant="subtitle">
        <TransText i18nKey="changeTotal" />:
      </Typography>
      {exchangePrice === null ? (
        <Typography variant="subtitle">-</Typography>
      ) : (
        <Typography
          variant="subtitle"
          className={exchangePrice <= 0 ? 'text-success-text' : 'text-primary'}
        >
          {formatSignedCurrency(exchangePrice, currency, locale)}
        </Typography>
      )}
    </div>
  );
};
